import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule, NgZone } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { MenuButtonComponent } from './menu-button/menu-button.component';
import { MenuCategoryOptionComponent } from './menu-category-option/menu-category-option.component';
import { MenuCategoryComponent } from './menu-category/menu-category.component';
import { MenuComponent } from './menu.component';
import { MatIconModule, MatMenuModule, MatDialogModule, MatTooltipModule } from '@angular/material';
import { UserIdleModule, UserIdleService } from 'angular-user-idle';
import { ItauUserIdleService } from '../../../core/security/itau-user-idle.service';
/*
export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient);
} */
import { FullMenuModule } from '../../../full-menu/full-menu.module';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(
        http, 
        './assets/i18n/', // or whatever path you're using
        '.json'
    );
  }

@NgModule({
    declarations: [
        MenuButtonComponent,
        MenuCategoryComponent,
        MenuCategoryOptionComponent,
        MenuComponent
    ],
    imports: [
        CommonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        UserIdleModule,
        MatTooltipModule,
        TranslateModule.forRoot({
            loader: {
              provide: TranslateLoader,
              useFactory: HttpLoaderFactory,
              deps: [HttpClient]
            }
          })
    ],
    providers: [
        ItauUserIdleService
    ],
    exports: [
        MenuComponent
    ]
})
export class MenuModule {}